import { motion } from "framer-motion";
import { cn } from "@/lib/utils";

interface StatusIndicatorProps {
  status: 'ready' | 'processing' | 'success' | 'error';
}

export function PaymentStatus({ status }: StatusIndicatorProps) {
  const getStatusConfig = () => {
    switch (status) {
      case 'ready':
        return { message: "Ready for payment" };
      case 'processing':
        return { message: "Processing payment..." };
      case 'success':
        return { message: "Payment successful!" };
      case 'error':
        return { message: "Payment failed" };
      default:
        return { message: "Unknown status" };
    }
  };

  const config = getStatusConfig();

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -10 }}
      className={cn(
        "p-4 rounded-lg",
        status === 'processing' && "bg-yellow-50",
        status === 'success' && "bg-green-50",
        status === 'error' && "bg-red-50"
      )}
    >
      <div className="flex items-center gap-2">
        <span className="text-sm font-medium">{config.message}</span>
      </div>
    </motion.div>
  );
}